import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { Category } from '@vendorhub/shared/domain/catalog';
import { VhIconComponent } from '../icon/icon.component';
import type { VhIconName } from '../icon/vh-icons';

/**
 * Square category tile for home and category rails. Icon + name +
 * product count. Click routes to `/categories/:slug`.
 */
@Component({
  selector: 'vh-category-tile',
  standalone: true,
  imports: [RouterLink, VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a [routerLink]="detailRoute()" class="vh-category-tile__link">
      <span class="vh-category-tile__icon" aria-hidden="true">
        <vh-icon [name]="iconName()" size="lg" />
      </span>
      <span class="vh-category-tile__name">{{ category().name }}</span>
      <span class="vh-category-tile__count">{{ category().productCount }} products</span>
    </a>
  `,
  styleUrl: './category-tile.component.scss',
})
export class VhCategoryTileComponent {
  readonly category = input.required<Category>();

  readonly detailRoute = computed(() => ['/categories', this.category().slug]);
  readonly iconName = computed<VhIconName>(
    () => (this.category().icon as VhIconName) ?? 'shopping-bag',
  );
}
